type DataSet = Record<string, string | undefined>

export function toDataSet(record?: DataSet): DataSet {
  return Object.keys(record || {}).reduce(
    (previous: DataSet, current: string) => {
      const key = `data-${current.replace(
        /[A-Z]/g,
        (match) => '-' + match.toLowerCase(),
      )}`

      if (record) {
        previous[key] = record[current]
      }

      return previous
    },
    {},
  )
}
